/**
 * Calculates CSS object-position style from PayloadCMS focal point values.
 *
 * PayloadCMS stores focal points in 0-100 range (percentage-based).
 * This function converts them to CSS object-position format (e.g., "50% 30%").
 *
 * @param focalX - Focal point X coordinate (0-100 range, or null/undefined)
 * @param focalY - Focal point Y coordinate (0-100 range, or null/undefined)
 * @returns Object with objectPosition style property, or empty object if focal points are not set
 *
 * @example
 * ```ts
 * const style = getFocalPointStyle(50, 30)
 * // Returns: { objectPosition: "50% 30%" }
 *
 * const style = getFocalPointStyle(null, null)
 * // Returns: {}
 * ```
 */
export function getFocalPointStyle(
  focalX?: number | null,
  focalY?: number | null,
): { objectPosition: string } | Record<string, never> {
  // Both focalX and focalY must be set and not null
  if (focalX != null && focalY != null) {
    // Clamp values to 0-100 range and convert to percentage string
    const x = Math.max(0, Math.min(100, focalX))
    const y = Math.max(0, Math.min(100, focalY))
    return { objectPosition: `${x}% ${y}%` }
  }

  // Return empty object when focal points are not set
  return {}
}






















